// extracted by mini-css-extract-plugin
module.exports = {"title":"title-1f177428","error":"error-ef3e8059","comparison":"comparison-6241a95f"};